/* ============================================================
   Nutry v2 — homepage hero, SKU paint, sticky shop bar, notify drawer.
   Data comes from window.NUTRY (header) and window.NUTRY_HERO (hero section).
   ============================================================ */
(() => {
  "use strict";
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const D  = window.NUTRY || {};
  const H  = window.NUTRY_HERO || {};
  const SKUS = D.skus || [];
  const bySku = k => SKUS.find(s => s.key === k);
  const money = c => (c / 100).toLocaleString("en-US", { maximumFractionDigits: 0 }) + " EGP";

  /* ---------- paint: nav, bar and CTA follow the SKU in view ---------- */
  let cur = null;
  function paint(key) {
    const s = bySku(key);
    if (!s || cur === key) return;
    cur = key;
    const r = document.documentElement.style;
    r.setProperty("--ground", s.ground);
    r.setProperty("--ink", s.ink);
    r.setProperty("--stage2", s.stage2);
    r.setProperty("--accent", s.accent);
    r.setProperty("--accent-ink", s.accentInk || "#F7F5F0");

    const line = $("#h2Line"), cta = $("#h2Cta"), lead = $("#h2Lead"), price = $("#h2Price");
    const copy = (H.lines && H.lines[key]) || "";
    const swap = () => {
      if (line) line.textContent = copy;
      if (lead) lead.innerHTML = s.live ? `Shop <b>${s.chip}</b>` : `<b>Notify me</b>`;
      if (price) price.textContent = s.live ? `${s.packShort} · ${money(s.price)} →` : `${s.chip} · soon →`;
      if (cta) {
        cta.setAttribute("href", s.live ? s.url : "#notify");
        cta.toggleAttribute("data-notify", !s.live);
        if (!s.live) cta.setAttribute("data-notify", key);
      }
    };
    /* the words change in the same frame, no fade: iOS Safari left a stale layer of the old sentence behind a fading one */
    swap();

    const bn = $("#v2barName"), bm = $("#v2barMeta"), bb = $("#v2barBtn");
    /* price on the name line, the hint alone on the meta line, so nothing truncates next to the button */
    if (bn) bn.textContent = s.live ? `${s.name} · ${money(s.price)}` : s.name;
    if (bm) bm.textContent = s.live ? (D.barHint || "") : "coming soon";
    if (bb) {
      bb.innerHTML = s.live ? 'Shop <span class="arrow">→</span>' : 'Notify me <span class="arrow">→</span>';
      bb.setAttribute("href", s.live ? s.url : "#notify");
      if (s.live) bb.removeAttribute("data-notify"); else bb.setAttribute("data-notify", key);
    }
    $$("#h2Switch button").forEach(b => b.setAttribute("aria-selected", String(b.dataset.sku === key)));
  }
  window.nutryPaint2 = paint;

  /* ---------- hero: swipe is native scroll-snap; chips glide ---------- */
  const track = $("#h2Track");
  if (track) {
    const order = $$(".h2-slide", track).map(el => el.dataset.sku);
    paint(order[0], true);
    /* one nudge after load so the hero reads as swipeable; cancelled the moment the visitor scrolls it */
    track.classList.add("nudge");
    track.addEventListener("scroll", () => track.classList.remove("nudge"), { once: true, passive: true });
    track.addEventListener("animationend", () => track.classList.remove("nudge"), { once: true });

    /* the two hidden slides' images: load once the page is idle, or the moment the user reaches for them */
    let woke = false;
    const wake = () => {
      if (woke) return; woke = true;
      $$("img[data-src]", track).forEach(img => {
        img.srcset = img.dataset.srcset || ""; img.src = img.dataset.src;
        img.removeAttribute("data-src"); img.removeAttribute("data-srcset");
      });
    };
    const idle = () => ("requestIdleCallback" in window ? requestIdleCallback(wake, { timeout: 2500 }) : setTimeout(wake, 1500));
    if (document.readyState === "complete") idle(); else addEventListener("load", idle, { once: true });
    track.addEventListener("touchstart", wake, { passive: true, once: true });
    track.addEventListener("pointerdown", wake, { passive: true, once: true });

    let raf = 0, settle = 0;
    track.addEventListener("scroll", () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        clearTimeout(settle);
        settle = setTimeout(() => paint(order[Math.round(track.scrollLeft / track.clientWidth)] || order[0]), 120);
      });
    }, { passive: true });

    /* native smooth scroll stops at the first snap point when snap-stop is "always" — ease it by hand */
    function glide(to) {
      const from = track.scrollLeft, d = to - from, t0 = performance.now(), dur = 420;
      if (!d) return;
      track.style.scrollSnapType = "none";
      (function step(now) {
        const p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = from + d * e;
        if (p < 1) requestAnimationFrame(step); else track.style.scrollSnapType = "";
      })(t0);
    }
    const sw = $("#h2Switch");
    if (sw) sw.addEventListener("click", e => {
      const b = e.target.closest("button"); if (!b) return;
      wake();
      glide(order.indexOf(b.dataset.sku) * track.clientWidth);
      paint(b.dataset.sku);
    });

    /* sticky bar once the hero has left */
    const bar = $("#v2bar"), hero = $("#h2"), card = $("#ln3card") || $("#products");
    if (bar && hero && "IntersectionObserver" in window) {
      /* the bar shows once the hero has scrolled off, and hides again while the product card itself is on screen */
      let heroGone = false, cardOn = false;
      const apply = () => {
        const on = heroGone && !cardOn;
        bar.classList.toggle("on", on);
        bar.setAttribute("aria-hidden", String(!on));
        bar.toggleAttribute("inert", !on);
      };
      new IntersectionObserver(([en]) => {
        heroGone = !en.isIntersecting && en.boundingClientRect.top < 0;
        apply();
      }, { threshold: 0 }).observe(hero);
      if (card) new IntersectionObserver(([en]) => { cardOn = en.isIntersecting; apply(); }, { rootMargin: "0px 0px -35% 0px", threshold: 0 }).observe(card);
    }
  }

  /* ---------- what's in it (range): one product at a time ---------- */
  const tabs = $(".cl3-tabs");
  if (tabs) tabs.addEventListener("click", e => {
    const b = e.target.closest("button[data-pane]"); if (!b) return;
    $$("button", tabs).forEach(x => x.setAttribute("aria-selected", String(x === b)));
    $$(".cl3-led[data-pane]").forEach(p => { p.hidden = p.dataset.pane !== b.dataset.pane; });
    const h = $("#cl3H"); if (h) h.textContent = b.dataset.h;
  });

  /* ---------- notify drawer: any [data-notify] opens it with the SKU set ---------- */
  const panel = $("#notify"), scrim = $("#notifyScrim");
  if (panel && scrim) {
    let last = null;
    const open = key => {
      const s = bySku(key);
      const nm = $("#notifyName"), sk = $("#notifySku"), body = $("#notifyBody");
      if (nm && s) nm.textContent = s.chip;
      /* tags on the saved customer: "notify" for everyone on the list, "notify-<sku>" for the segment */
      if (sk) sk.value = `notify, notify-${key}`;
      if (body) body.value = `Notify me when ${key} honey lands.`;
      if (s) panel.style.setProperty("--nc", s.accent);
      last = document.activeElement;
      scrim.hidden = false;
      requestAnimationFrame(() => { scrim.classList.add("on"); panel.classList.add("on"); });
      panel.setAttribute("aria-hidden", "false");
      panel.removeAttribute("inert");
      document.body.style.overflow = "hidden";
      document.body.classList.add("drawer-open");
      const inp = $("#notifyEmail"); if (inp) setTimeout(() => inp.focus(), 380);
    };
    const close = () => {
      scrim.classList.remove("on"); panel.classList.remove("on");
      panel.setAttribute("aria-hidden", "true");
      panel.setAttribute("inert", "");
      document.body.style.overflow = "";
      document.body.classList.remove("drawer-open");
      setTimeout(() => { scrim.hidden = true; }, 420);
      if (last) last.focus();
    };
    document.addEventListener("click", e => {
      const t = e.target.closest("[data-notify]");
      if (!t) return;
      e.preventDefault();
      open(t.getAttribute("data-notify"));
    });
    const x = $("#notifyX"); if (x) x.addEventListener("click", close);
    scrim.addEventListener("click", close);
    addEventListener("keydown", e => { if (e.key === "Escape" && panel.classList.contains("on")) close(); });
    /* the form posted back to this page: reopen the drawer on the result. Shopify's redirect carries the
       form's own id as the hash (#notifyForm), so don't gate on a particular hash; the inline data flags are enough */
    if (panel.dataset.posted === "1" || panel.dataset.errors === "1") {
      open(panel.dataset.sku || (SKUS.find(s => !s.live) || {}).key);
    }
  }
})();
